// extracted by mini-css-extract-plugin
export var attribution = "_df-4";
export var authorName = "_df-5";
export var quote = "_df-3";
export var testimonial = "_df-2";
export var trustedBy = "_df-0";
export var trustedByLabel = "_df-1";